/**
 * FomoNotificationContainer - Container for FOMO notifications
 *
 * Manages positioning and renders notifications with AnimatePresence.
 */

import { AnimatePresence } from 'framer-motion'
import { useFomoNotifications } from './useFomoNotifications'
import FomoNotification from './FomoNotification'

// Position styles mapping
const POSITION_STYLES = {
  'top-left': 'top-20 left-4',
  'top-right': 'top-20 right-4',
  'top-middle': 'top-20 left-1/2 -translate-x-1/2',
  'bottom-left': 'bottom-4 left-4',
  'bottom-right': 'bottom-4 right-4',
  'bottom-middle': 'bottom-4 left-1/2 -translate-x-1/2'
}

export default function FomoNotificationContainer() {
  const { config, currentNotification, dismiss } = useFomoNotifications()

  // Don't render if disabled or no notification
  if (!config?.enabled) {
    return null
  }

  const positionClass = POSITION_STYLES[config.position] || POSITION_STYLES['top-right']

  return (
    <div
      className={`fixed z-40 pointer-events-none ${positionClass}`}
      role="region"
      aria-label="Activity notifications"
      aria-live="polite"
    >
      <AnimatePresence mode="wait">
        {currentNotification && (
          <FomoNotification
            key={currentNotification.id}
            event={currentNotification}
            onClose={dismiss}
            position={config.position}
          />
        )}
      </AnimatePresence>
    </div>
  )
}
